<div class="container">

  <app-header-dialog [iconName]="'school'">
    Data Pagamento
  </app-header-dialog>

  <div class='content'>

    <form name="form" [formGroup]='form' autocomplete="off">

      <mat-form-field appearance="outline">
        <mat-label>Data</mat-label>
        <input matInput [matDatepicker]="pickerDate" [errorStateMatcher]="matcher"
          [formControl]="form.controls.order_date">
        <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
        <mat-datepicker #pickerDate></mat-datepicker>
      </mat-form-field>

    </form>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button [disabled]='form.invalid' mat-raised-button (click)="matDialogRef.close([ 'ok', form ])">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>